import { Site } from '@/common/const'
import { t } from '@/plugins/i18n'

export const tipList:any = {
  oemStatus: {
    name: 'oemStatus',
    title: t('春节前纳品oem商品截单日'),
    // 开始时间
    startTime: '2024/12/24 00:00:00',
    // 结束时间
    endTime: '2025/01/15 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 1,
    // 展示站点
    station: ['ja', 'en', 'ko'],
    tag: [
      {
        title: t('服装杂货'),
        time: t('★12/25（水）')
      },
      {
        title: t('辅料（纸盒，特殊纸袋，opp袋）'),
        time: t('★1/5（日）')
      },
      {
        title: t('辅料（布标，纸标，说明书）'),
        time: t('★1/15（水）')
      }
    ],
    text: [
      {
        text: t('oem订单请尽快下单！')
      },
      {
        text: t('※oem工厂春节休息时间：约1月初~2月中旬')
      },
      {
        text: t('※截单日之后也可以下单，但是工厂发货基本会延迟到2月下旬及以后~2月中旬')
      },
      {
        text: t('※每个工厂的情况不同，截单日之前的订单也会有春节后发货的可能性')
      }
    ]
  },
  stopPurchase: {
    name: 'stopPurchase',
    title: t('成品采购春节停止下单时间'),
    // 开始时间
    startTime: '2026/01/21 00:00:00',
    // 结束时间
    endTime: '2026/02/9 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 0,
    // 展示站点
    station: ['ja'],
    tag: [
      {
        title: '',
        time: '２月１０日（火）〜２月２３日（月）まで'
      }
    ],
    text: [
      {
        text: '※ショップによりますので、休業期間前のご注文でも春節後に発送される場合があります。'
      },
      {
        text: '※買付休業期間内の注文も受付可能ですが、２月24日以降順次対応させていただきます。'
      },
      {
        text: '※ショップ側の商品在庫切れを避けるために、１月下旬前に2ヶ月分の商品在庫を事前に確保するのをお勧めします。'
      }
    ]
  },
  expressTime: {
    name: 'expressTime',
    title: t('春节前希望发货的发货委托制作的推荐期间'),
    // 开始时间
    startTime: '2026/01/31 00:00:00',
    // 结束时间
    endTime: '2026/02/11 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 0,
    // 展示站点
    station: ['ja'],
    tag: [
      {
        title: t('船运节前出货发货依赖截单时间'),
        time: '２月１１日（水） まで'
      },
      {
        title: t('空运节前出货发货依赖截单时间'),
        time: '２月１１日（水） まで'
      }
    ],
    text: [
      {
        text: '※発送依頼締切期限前に発送依頼を行ってください。'
      }
    ]
  },
  marketPurchase: {
    name: 'marketPurchase',
    title: t('市场购春节停止拿货时间'),
    // 开始时间
    startTime: '2026/01/21 00:00:00',
    // 结束时间
    endTime: '2026/02/23 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 0,
    // 展示站点
    station: ['ja'],
    tag: [
      {
        title: '',
        time: '２月１日（木）~２月２３日（月）まで'
      }
    ],
    text: [
      {
        text: '※休暇時間はショップによりますので、休業期間前の注文でも買付できない場合があります。'
      },
      {
        text: '※休業期間中のご注文も受付可能で、２月24日以降順次対応いたします。"'
      }
    ]
  },
  oemSendCreate: {
    name: 'oemSendCreate',
    title: t('（注文，寻源）工厂停止生产'),
    // 开始时间
    startTime: '2026/02/11 00:00:00',
    // 结束时间
    endTime: '2026/02/23 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 1,
    // 展示站点
    station: ['ja'],
    tag: [
      {
        title: '',
        time: '２月１１日（水）~２月２３日（月）まで'
      }
    ],
    text: [
      {
        text: '※休業期間中でもOEM発注や見積依頼を受け付けております。'
      },
      {
        text: '旧正月明けに順次対応させていただきますので、発注希望の商品はは早めにご提出いただくことをお勧めいたします。'
      }
    ]
  },
  stopPurchaseOrder: {
    name: 'stopPurchaseOrder',
    title: t('成品订单 停止采购！'),
    // 开始时间
    startTime: '2026/02/10 00:00:00',
    // 结束时间
    endTime: '2026/02/23 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 0,
    // 展示站点
    station: ['ja'],
    tag: [
      {
        title: '',
        time: '２月１０日（火）~２月２３日（月）まで'
      }
    ],
    text: [
      {
        text: '※休業期間中でも注文を受け付けております。'
      },
      {
        text: '旧正月明けに順次対応させていただきますので、発注希望の商品はは早めにご提出いただくことをお勧めいたします。'
      }
    ]
  },
  stopWarehouse: {
    name: 'stopWarehouse',
    title: t('直行便仓库休息时间'),
    // 开始时间
    startTime: '2026/02/15 00:00:00',
    // 结束时间
    endTime: '2026/02/23 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 0,
    // 展示站点
    station: ['ja'],
    tag: [
      {
        title: t('D2C（仓库发货停止）'),
        time: '２月１５日（日）~２月１８日（水）、２月２２日（日）のみ'
      },
      {
        title: t('B2B（仓库发货停止）'),
        time: '２月１３日（金）~２月２３日（月）まで'
      },
      {
        title: '日本倉庫',
        time: '２月１５日（日）、２月２２（日）～２３日（月）のみ'
      }
    ],
    text: [
      {
        text: '※休業期間内でも発送依頼作成が可能ですが、営業再開降順次対応させていただきます。'
      }
    ]
  }
}
